import { Swiper, SwiperSlide } from "swiper/react";
import Link from "next/link";
import SwiperCore, { Mousewheel } from "swiper";
import ButtonCategory, { BUTTON_CATEGORY_TYPES } from "@/components/common/ButtonCategory";

SwiperCore.use([Mousewheel]);

const CategorySlider = ({ mainCategories }) => (
  <Swiper
    slidesPerView="auto"
    spaceBetween={10}
    breakpoints={{ 1024: { spaceBetween: 24 } }}
    mousewheel={{ forceToAxis: true }}
  >
    {mainCategories.map(({ main }) => (
      <SwiperSlide key={main.id} className="pt-6 lg:pt-8">
        <Link href={`/search?category=${main.slug}`} passHref>
          <ButtonCategory type={BUTTON_CATEGORY_TYPES.CATEGORY} tag="a">
            {main.name}
          </ButtonCategory>
        </Link>
      </SwiperSlide>
    ))}
  </Swiper>
);

export default CategorySlider;
